// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","caption2":"_3FCgXshmQfWC83mTTDn6Lf","caption":"_1dJD2pSCq2-UhXWE_3mRfd","errorRed":"#ff2a2a","infoGray":"#888888","borderGrey":"#d5dfdf","label":"_3OiFYhH7MwHBDG4y2YLpLM _3FCgXshmQfWC83mTTDn6Lf","info":"_1SVVuGJyuayER127VZJB29 _1dJD2pSCq2-UhXWE_3mRfd","error":"_3pAsMIAo35WrWv8UCAB6s8 _1dJD2pSCq2-UhXWE_3mRfd","input":"_3QcPIilI_Y2FJL30N1lFYe"};


//////////////////
// WEBPACK FOOTER
// ./src/common/mask-input/MaskInput.css
// module id = 721
// module chunks = 0